import React from 'react';

import ListAltIcon from '@material-ui/icons/ListAlt';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

import {
  PERMISSAO_TELA_COLABORADORES_LISTAR,
  PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR,
  PERMISSAO_TELA_DOCUMENTOS_LISTAR,
  PERMISSAO_TELA_FUNCOES_LISTAR,
  PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR,
  PERMISSAO_TELA_FARDAMENTOS_LISTAR,
  PERMISSAO_TELA_FERIADOS_LISTAR,
  PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR,
  PERMISSAO_TELA_QUALIDADES_LISTAR,
  PERMISSAO_TELA_DEFEITOS_LISTAR,
  PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR,
  PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR,
  PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR,
  PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR,
  PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR,
  PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_HORAS_EXTRAS_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuContabilidade = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
  totalAnalise,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Contabilidade"
    icon={<MoreHorizIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_COLABORADORES_LISTAR] &&
      hasResource('colaboradores')}
    {permissoes[PERMISSAO_TELA_FUNCOES_LISTAR] &&
      hasResource('funcoes_colaboradores')}
    {permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] &&
      hasResource('camisas_checagem')}
    {permissoes[PERMISSAO_TELA_FARDAMENTOS_LISTAR] &&
      hasResource('fardamentos')}
    {permissoes[PERMISSAO_TELA_FERIADOS_LISTAR] && hasResource('feriados')}
    {permissoes[PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR] &&
      hasResource('tamanhos_fardamentos')}
    {permissoes[PERMISSAO_TELA_QUALIDADES_LISTAR] &&
      hasResource('qualidades_colaborador')}
    {permissoes[PERMISSAO_TELA_DEFEITOS_LISTAR] &&
      hasResource('defeitos_colaborador')}
    {permissoes[PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR] &&
      hasResource('descontos-funcionarios-relatorio')}
    {permissoes[PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR] &&
      hasResource('categorias_descontos_funcionarios')}
    {permissoes[PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR] &&
      hasResource('grupos_colaborador')}
    {permissoes[PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR] &&
      hasResource('equipes_colaborador')}
    {permissoes[PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR] &&
      hasResource('codinomes_colaborador')}
    {permissoes[PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR] &&
      hasResource('produtos_codinomes')}
    {permissoes[PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR] &&
      hasResource('departamentos_colaborador')}
    {permissoes[PERMISSAO_TELA_HORAS_EXTRAS_LISTAR] && (
      <StyledMenuItemLink
        key="horas-extras"
        to="/horas-extras"
        primaryText="Horas Extras"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR] &&
      hasResource('modelos_documentos')}
    {permissoes[PERMISSAO_TELA_DOCUMENTOS_LISTAR] &&
      hasResource('documentos', totalAnalise)}
  </SubMenu>
);

export default SubMenuContabilidade;
